const UserStats = ({ followersCount, isFollowersLoading, followingCount, isFollowingLoading }) => {
    return (
        <div className="item">
            <span className="title">User Statistics</span>
        
            <div className="statsRow">
                <div className="statBox">
                    <span className="count">
                        {isFollowersLoading ? "..." : followersCount}
                    </span>

                    <span className="label">
                        Followers
                    </span>
                </div>

                <div className="divider"></div>
                
                <div className="statBox">
                    <span className="count">
                        {isFollowingLoading ? "..." : followingCount}
                    </span>

                    <span className="label">
                        Following
                    </span>
                </div>
            </div>
        </div>
    );
};

export default UserStats;